<template>
  <a
    href="#"
    @click.prevent="clickStr"
    class="ut-mt-4 md:ut-mt-0 md:ut-mr-8 ut-text-sm ga-event"
    :data-category="gacategory"
    :data-eventlabel="gaeventlabel"
    :data-eventvalue="gaeventvalue"
    :data-eventvaluetype="gaeventvaluetype"
    :class="{ 'email': email, 'phone' : !email }"
  >{{ strValue }}</a>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ClickToShow',
  props: {
    str: {
      default: '',
      required: true,
    },
    email: {
      default: false,
      required: false,
    },
    formate: {
      default: false,
      required: true,
    },
    isvendor: {
      default: false,
    },
    gacategory: { default: null, },
    gaeventlabel: { default: null, },
    gaeventvalue: { default: null, },
    gaeventvaluetype: { default: null, },
  },
  data() {
    return {
      // formatted: this.formate,
    };
  },
  methods: {
    formatString() {
      if (this.email) {
        return `${this.str.substr(0, 1)}..@...`;
      }
      return `${this.str.substr(0, 4)} ... ...`;
    },

    clickStr() {
      if (this.email) {
        this.clickEmail();
      } else {
        this.clickPhone();
      }
      // if (!this.formatted) {
      if (!this.formate) {
        this.$emit('clicked-show');
      }
      // change the flag after first click so mobile phone call won't be triggered in first time
      // this.formatted = true;
    },
    clickPhone() {
      if (this.formate) {
        let callee = 'consultant';
        if (this.isvendor) {
          callee = 'vendor';
        }

        // this.addGA('Agent Referral', `Click to call ${callee}`, this.gaLabel());

        window.location = `tel: ${this.str}`;
      } else {
        // this.addGA('Agent Referral', 'Click to show phone', this.gaLabel());
      }
    },
    clickEmail() {
      if (this.formate) {
        let callee = 'consultant';
        if (this.isvendor) {
          callee = 'vendor';
        }
        // this.addGA('Agent Referral', `Click to email ${callee}`, this.gaLabel());

        window.location = `mailto: ${this.str}`;
      } else {
        // this.addGA('Agent Referral', 'Click to show email', this.gaLabel());
      }
    },
    // addGA(category, action, label) {
    //   this.$helpers.gaEvent(category, action, label);
    // },
    gaLabel() {
      return `AID=${this.lam.agentid} | CurrentStage=${this.lam.stagetypeid} | CurrentState=${this.lam.statetypeid}`;
      // return `AID=${this.agent.id} | CurrentStage=${this.lam.stagetypeid} | CurrentState=${this.lam.statetypeid}`;
    },
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      lam: state => state.leadAgentMappingStore.lam,
    }),
    strValue() {
      // if (!this.formatted) {
      if (!this.formate) {
        return this.formatString();
      }
      return this.str;
    },
  },
};
</script>

<style scoped lang="scss">
  a {
    @apply ut-block;
    color: #545352;

    &.phone {

      @apply ut-tracking-wide;

      &::before {
          @apply ut-inline-block ut-mr-3;
          content: url("../assets/styles/frontend-library/images/phone-grey.svg");
          vertical-align: middle;
          height: 24px;
        }
    }

    &.email::before {
      @apply ut-inline-block ut-mr-3;
      content: url("../assets/styles/frontend-library/images/mail-grey.svg");
      vertical-align: middle;
      height: 24px;
    }

    @screen md {
      @apply ut-inline-block;
    }
  }
</style>
